import { Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { Note } from "../model/note.model";
import { NoteFormBuilder } from "../shared/note-form-builder";

@Component({
    selector: "note",
    templateUrl: "./note.component.html",
    styleUrls: ["./note.component.scss"]
})
export class NoteComponent {
    @Input() public formGroup: UntypedFormGroup;

    public get valid(): boolean {
        return this.formGroup && this.formGroup.valid;
    }

    public get dirty(): boolean {
        return this.formGroup && this.formGroup.dirty;
    }

    public get value(): Note {
        return NoteFormBuilder.formGroupToNote(this.formGroup);
    }
}
